import React, { useState, useEffect, useContext } from "react";
import "./NavBar2.css";
import ProgressContext from "./ProgressContext";
import { API_BASE_URL, LOGOUT_URL } from "./config";

const Navbar2 = ({ setPage, currentPage }) => {
  const { progress } = useContext(ProgressContext);
  const [DayDuration, setDayDuration] = useState("NA");
  const [loading, setLoading] = useState(true);

  const logoutUrl = LOGOUT_URL;

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const studentUniqueId = localStorage.getItem("student_unique_id");
        const token = localStorage.getItem("token");

        if (studentUniqueId && token) {
          const response = await fetch(
            `${API_BASE_URL}/student_JoinDate/${studentUniqueId}?token=${token}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
              },
            }
          );

          if (response.status === 200) {
            const data = await response.json();
            setDayDuration(data["days_difference"]);
            setLoading(false);
          } else if (response.status === 403 || response.status === 401) {
            localStorage.removeItem("student_unique_id");
            localStorage.removeItem("token");
            localStorage.removeItem("first_name");
            window.location.href = logoutUrl;
          } else {
            setLoading(false);
            console.error("Failed to fetch details:", response.statusText);
          }
        } else {
          setLoading(false);
          console.error("Student Unique ID not found in local storage");
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, [logoutUrl]);

  const handleLogout = () => {
    localStorage.removeItem("student_unique_id");
    localStorage.removeItem("token");
    localStorage.removeItem("first_name");
    window.location.href = logoutUrl || "/";
  };

  const navItems = [
    {
      key: "CompleteSyllabus",
      label: "Learning Roadmap",
      short: "Roadmap",
      icon: "⚡",
    },
    {
      key: "Assignment",
      label: "Assignments",
      short: "Tasks",
      icon: "🧠",
    },
    {
      key: "Placement",
      label: "Placement Prep",
      short: "Placement",
      icon: "🚀",
    },
    {
      key: "MyProfile",
      label: "My Profile",
      short: "Profile",
      icon: "👤",
    },
  ];

  if (loading) {
    return (
      <div className="student-nav-shell">
        <div className="student-nav-loading">Loading student system...</div>
      </div>
    );
  }

  return (
    <header className="student-nav-shell">
      <div className="student-nav-inner">
        <div className="student-nav-top">
          <div className="student-brand-block">
            <div className="student-brand-mark">SA</div>

            <div className="student-brand-copy">
              <p>STUDENT COMMAND CENTER</p>
              <h3>StudyAIPlacement Learning System</h3>
            </div>
          </div>

          <div className="student-progress-card">
            <div className="student-progress-meta">
              <span>Progress</span>
              <strong>{`${Number(progress || 0).toFixed(2)}%`}</strong>
            </div>

            <div className="student-progress-track">
              <div
                className="student-progress-fill"
                style={{ width: `${Math.min(Number(progress || 0), 100)}%` }}
              />
            </div>

            <div className="student-progress-day">Day - {DayDuration}</div>
          </div>

          <button className="student-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <nav className="student-tab-nav">
          {navItems.map((item) => (
            <button
              key={item.key}
              className={
                currentPage === item.key
                  ? "student-tab-btn active-student-tab"
                  : "student-tab-btn"
              }
              onClick={() => setPage(item.key)}
            >
              <span className="student-tab-icon">{item.icon}</span>
              <span className="student-tab-label">{item.label}</span>
              <span className="student-tab-short">{item.short}</span>
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Navbar2;